class FeatureReviews extends HTMLElement {
  constructor() {
    super();
    this.reviews = this.querySelectorAll(".featured-reviews__slide");
    this.profiles = this.querySelectorAll(".featured-reviews__image");
    this.nextButton = this.querySelector(
      ".prev-next-arrow-button__arrow--next "
    );
    this.previousButton = this.querySelector(
      ".prev-next-arrow-button__arrow--prev"
    );

    this.total = this.reviews.length;
    this.current = 0;

    console.log(this.total, this.total <= 1, this.nextButton);

    if (this.total > 1) {
      this.nextButton.classList.add("featured-reviews__arrow--show");
      this.previousButton.classList.add("featured-reviews__arrow--show");
    }

    if (this.nextButton && this.previousButton) {
      this.nextButton.addEventListener("click", () => {
        this.next();
      });
      this.previousButton.addEventListener("click", () => {
        this.previous();
      });
    }
  }

  next() {
    let next = this.current;
    this.current += 1;
    this.setSlide(next, this.current);
  }
  previous() {
    let prev = this.current;
    this.current -= 1;
    this.setSlide(prev, this.current);
  }
  setSlide(prev, next) {
    this.slide = this.current;
    if (next > this.total - 1) {
      this.slide = 0;
      this.current = 0;
    }

    if (next < 0) {
      this.slide = this.total - 1;
      this.current = this.total - 1;
    }
    this.reviews[prev].classList.remove("featured-reviews--show");
    this.profiles[prev].classList.remove("featured-reviews--show");
    this.reviews[this.slide].classList.add("featured-reviews--show");
    this.profiles[this.slide].classList.add("featured-reviews--show");
    // sengoku youko
  }
}

window.addEventListener("DOMContentLoaded", () =>
  customElements.define("featured-reviews", FeatureReviews)
);
